import Lenis from "lenis";

let lenis = null;

export function initLenis() {
    if (lenis) return lenis;
    lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    const raf = (time) => {
        lenis.raf(time);
        requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return lenis;
}

export function lenisScrollTo(target) {
    if (!lenis) {
        if (target) {
            const el = document.querySelector(target);
            if (el) el.scrollIntoView({ behavior: "smooth" });
        } else {
            window.scrollTo(0, 0);
        }
        return;
    }
    if (target) {
        const el = document.querySelector(target);
        if (el) {
            lenis.scrollTo(el, { offset: -96 });
            return;
        }
    }
    lenis.scrollTo(0, { immediate: true });
}
